import { render } from "./chat-question.vue?vue&type=template&id=288210e8"
import script from "./chat-question.vue?vue&type=script&lang=js"
export * from "./chat-question.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__